<template>
  <div>
    <v-card flat>
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4">Administrators</v-col>
          <v-col cols="5">
            <v-text-field
              v-model="ui.admins.search"
              label="Search"
              single-line
              hide-details
              clearable
            >
              <template v-slot:append>
                <v-icon color="primary">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <AdministratorCreate class="ml-4" v-if="role == 'ADMIN'" />
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="administator.administrators"
        :search.sync="ui.admins.search"
        :page.sync="ui.admins.page"
        :items-per-page.sync="ui.admins.perPage"
        :footer-props="{ 'items-per-page-options': [10, 30, 50, 100] }"
      >
        <template v-slot:item.superUser="{ item }">
          <v-checkbox
            v-model="item.superUser"
            :disabled="!user.superUser"
            @click="updateUser(item)"
          ></v-checkbox>
        </template>

        <template v-slot:item.creationDate="{ item }">{{
          item.creationDate | date
        }}</template>
        <template v-slot:item.action="{ item }" v-if="role == 'ADMIN'">
          <v-btn
            tile
            text
            class="ml-2 my-4 px-6 primary"
            height="60"
            @click="onDelete(item)"
            >Remove</v-btn
          >
        </template>
      </v-data-table>
    </v-card>
    <v-dialog width="400" v-model="dialogDelete" v-if="role == 'ADMIN'">
      <v-card>
        <v-card-title>Remove Administrator</v-card-title>
        <v-card-text class="text--primary">
          Are you sure you want to remove
          <span class="subtitle-2 font-weight-bold">{{ deleteItem.email }}</span
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            tile
            class="ma-2"
            color="primary"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            tile
            text
            class="ma-2 primary"
            @click="onDeleteAdmin"
            :loading="pending"
            >Remove</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapActions, mapState } from "vuex";

export default Vue.extend({
  name: "AdminsList",
  components: {
    AdministratorCreate: () =>
      import("@/components/Dashboard/AdministratorCreate"),
  },
  data() {
    return {
      search: "",
      dialogDelete: false,
      pending: false,
      deleteItem: {},
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
        },
        { text: "Email", value: "email" },
        { text: "SuperUser", value: "superUser" },
        { text: "ID", value: "_id" },
        { text: "Created", value: "creationDate" },
        { text: "", value: "action", sortable: false, align: "right" },
      ],
    };
  },
  computed: {
    ...mapGetters(["role", "user"]),
    ...mapState(["administator", "ui"]),
    numberOfPages() {
      return Math.ceil(this.advertisers.length / this.itemsPerPage);
    },
  },
  methods: {
    ...mapActions([
      "fetchAdministrators",
      "deleteAdmin",
      "setSnackbar",
      "updateAdmin",
    ]),
    onDelete(item) {
      this.dialogDelete = true;
      this.deleteItem = item;
    },
    async updateUser(user) {
      try {
        await this.updateAdmin(user);
        this.setSnackbar({
          text: `Admin updated.`,
        });
      } catch (err) {
        console.log(err);
      }
    },
    async onDeleteAdmin() {
      this.pending = true;
      try {
        await this.deleteAdmin(this.deleteItem._id);
        this.dialogDelete = false;
        this.pending = false;
        this.deleteId = {};
        this.setSnackbar({
          text: `Admin removed.`,
        });
      } catch (error) {
        // console.log(error);
      }
    },
    customFilter(items, search) {
      if (search == "") return items;
      search = search.toLowerCase();
      return items.filter((item) => {
        return (
          item.name.toString().toLowerCase().indexOf(search) !== -1 ||
          (item.description || "").toString().toLowerCase().indexOf(search) !==
            -1
        );
      });
      //   return value != null && search != null && typeof value === "string";
    },
  },
  mounted() {
    this.fetchAdministrators();
  },
});
</script>
